import styled from 'styled-components';
import { Button } from '../../../components/uielements';

export const Container = styled.div`
  max-width: 90%;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 100px;
`;

export const Title = styled.h1`
  font-size: 1.8rem;
  margin-bottom: 2rem;
  color: #2c3e50;
  text-align: center;
  padding-bottom: 1rem;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const ReportContent = styled.div`
  background-color: white;
  padding: 2rem;
  border-radius: 4px;

  h3 {
    color: #3498db;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1rem;
    line-height: 1.6;
  }

  a {
    color: #3498db;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 50px 0px 40px 0px;
`;

export const LinkButton = styled(Button)`
  padding: 0px 40px;
`;

export const StatusBadge = styled.div`
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  background-color: ${(props) =>
    props.status === 'success'
      ? '#e6f7ee'
      : props.status === 'pending'
        ? '#fff7e6'
        : props.status === 'error'
          ? '#fff1f0'
          : '#e6f7ff'};
  color: ${(props) =>
    props.status === 'success'
      ? '#52c41a'
      : props.status === 'pending'
        ? '#faad14'
        : props.status === 'error'
          ? '#f5222d'
          : '#1890ff'};
  border: 1px solid
    ${(props) =>
      props.status === 'success'
        ? '#b7eb8f'
        : props.status === 'pending'
          ? '#ffe58f'
          : props.status === 'error'
            ? '#ffa39e'
            : '#91d5ff'};
`;
